import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('ro/inter-branch-transfer/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('ro/reports/inter-branch-transfer/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('ro/exports/inter-branch-transfer/receivings', { params })
  },

  async show (id) {
    return axios.get(`ro/inter-branch-transfer/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('ro/inter-branch-transfer/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`ro/inter-branch-transfer/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`ro/inter-branch-transfer/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
